import apiClient, { extractData } from './client';

export async function getCompensatoryPending(params = {}) {
  const response = await apiClient.get('/compensatory/pending', { params });
  return extractData(response);
}

export async function getMyCompensatoryPending(params = {}) {
  const response = await apiClient.get('/compensatory/pending/mine', { params });
  return extractData(response);
}

export async function getCompensatoryBalance(params = {}) {
  const response = await apiClient.get('/compensatory/balance', { params });
  return extractData(response);
}

export async function convertToCompensatory(attendanceRecordIds) {
  const response = await apiClient.post('/compensatory/convert', {
    attendanceRecordIds,
  });
  return extractData(response);
}

export async function markAttendancePaidOt(attendanceRecordIds) {
  const response = await apiClient.post('/compensatory/mark-paid-ot', {
    attendanceRecordIds,
  });
  return extractData(response);
}
